import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  Descriptions,
  Image as Image1,
  Table,
  Pagination,
  Checkbox,
  Popover,
  Select,
  Space,
  Button,
  Tooltip,
  Row,
  Col,
  Typography,
} from "antd";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";

import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { get_printer_list, reprint_child_qr } from "../../utils/api";
import html2canvas from "html2canvas";

// Component and icon aliases for compatibility
const Stack = Space;
const Grid = ({ item, container, xs, lg, style, children, ...props }) => {
  if (container) {
    return <Row style={style} {...props}>{children}</Row>;
  }
  if (item) {
    return <Col xs={xs} lg={lg} style={style} {...props}>{children}</Col>;
  }
  return <div style={style} {...props}>{children}</div>;
};
const Paper = ({ ref, elevation, style, children, ...props }) => {
  return <div ref={ref} style={{ boxShadow: elevation ? '0 2px 8px rgba(0,0,0,0.15)' : 'none', ...style }} {...props}>{children}</div>;
};
const IconButton = Button;
const FileDownloadIcon = DownloadOutlined;
const LocalPrintshopIcon = PrinterOutlined;

function ReprintQr({
  set_show_qr,
  show_qr,
  set_qr_image,
  qr_image,
  componentRef,
  selected_record,
}) {
  const navigate = useNavigate();
  const [printerData, setPrinterData] = useState([]);
  const handleOk = () => { };
  const [selectedPrinter, setSelectedPrinter] = useState("");

  const printQrByIP = async (req) => {
    try {
      await reprint_child_qr(req, success_print_qr);
    } catch (error) {
      console.log(error);
    }
  };

  const success_print_qr = (res) => {
    if (res?.status === "success") {
      toast?.success(res?.message);
    } else {
      toast?.warning(res?.message);
    }
  };

  const getPrinterList = async () => {
    try {
      await get_printer_list(success_get_printer_list);
    } catch (error) {
      console.log(error);
    }
  };

  const success_get_printer_list = (res) => {
    setPrinterData(res?.data?.data);
  };

  const handleCancel = () => {
    set_show_qr(false);
    setSelectedPrinter("");
    set_qr_image();
  };

  // useEffect(() => {
  //   getPrinterList();
  // }, []);
  // -----------------pagination------------------------
  useEffect(() => {
    console.log(qr_image);
  }, [qr_image]);
  return (
    <>
      <Modal
        open={show_qr}
        title=""
        onOk={handleOk}
        width={800}
        onCancel={handleCancel}
        footer={[]}
      >
        <Stack
          direction="vertical"
          align="center"
          style={{ height: "100%", width: "100%" }}
        >
          {/* <Image1 style={{ width: "350px", height: "auto" }}  src={`data:image/png;base64,${qr_image}`} /> */}
          <Paper
            ref={componentRef}
            elevation={3}
            style={{ padding: "12px", maxWidth: "100%", margin: "auto" }}
          >
            <Grid container>
              <>
                <Grid
                  container
                  item
                  xs={7}
                  lg={7}
                  style={{ padding: "8px", maxWidth: "100%", margin: "auto" }}
                >
                  <Grid item xs={7}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      <strong>Material No :</strong>
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      {qr_image?.material_unique_id}
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      <strong>Batch:</strong>
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      {selected_record?.batch_number}
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      <strong>Pack Qty :</strong>
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      {qr_image?.quantity}
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      <strong>Packs :</strong>
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      {`${qr_image?.pack_1}/${qr_image?.pack_2}`}
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      <strong>Pack Status :</strong>
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      {"R"}
                    </Typography.Text>
                  </Grid>
                  {selected_record?.qr_type !== "M" && <><Grid item xs={7}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      <strong>Gross Weight :</strong>
                    </Typography.Text>
                  </Grid>
                    <Grid item xs={5}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.gross_weight}
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Net Weight :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.net_weight}
                      </Typography.Text>
                    </Grid>

                    <Grid item xs={7}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        <strong>Tare Weight :</strong>
                      </Typography.Text>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography.Text
                        style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                      >
                        {qr_image?.tare_weight}
                      </Typography.Text>
                    </Grid></>}
                  <Grid item xs={7}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      <strong>Exp Date :</strong>
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      {qr_image?.expiry_date}
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      <strong>Open Date :</strong>
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      {qr_image?.open_date}
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={7}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      <strong>Lot No:</strong>
                    </Typography.Text>
                  </Grid>
                  <Grid item xs={5}>
                    <Typography.Text
                      style={{ fontSize: "clamp(0.7rem, 1.5vw, 1.1rem)" }}
                    >
                      {qr_image?.lot_number}
                    </Typography.Text>
                  </Grid>
                </Grid>
              </>

              {/* Right Grid - QR Code Image */}
              <Grid item xs={5}>
                <img
                  src={`data:image/png;base64,${qr_image?.qr_code}`}
                  alt="QR Code"
                  style={{
                    width: "100%",
                    height: "auto",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
          <Stack direction="horizontal" align="center">
            {/* <Select
              allowClear
              showSearch
              id="demo-select-small"
              value={selectedPrinter || null}
              size="medium"
              style={{
                width: "100%",
                
                borderRadius: "3px",
              }}
              bordered
              placeholder="Select Printer"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              filterSort={(optionA, optionB) =>
                optionA.children.localeCompare(optionB.children)
              }
              dropdownStyle={{
                width: "200px",
                maxHeight: 400,
                overflow: "auto",
              }}
              onChange={(value, option) => {
                setSelectedPrinter(value);
              }}
            >
              {printerData?.map((item) => (
                <Select.Option key={item.machine_id} value={item.id}>
                  {item.machine_name}
                </Select.Option>
              ))}
            </Select> */}
            <Tooltip title="Print">
              <IconButton
                type="text"
                icon={<LocalPrintshopIcon style={{ color: "#1890ff" }} />}
                //disabled={!selectedPrinter}
                onClick={async () => {
                  const req = {
                    material_id: selected_record?.material_id,
                    batch_number: selected_record?.batch_number,
                    operation_id: selected_record?.operation_id,
                    qr_type: selected_record?.qr_type,
                  };

                  printQrByIP(req);
                }}
              />
            </Tooltip>
            <Tooltip title="Download">
              <IconButton
                type="text"
                icon={<FileDownloadIcon style={{ color: "#1890ff" }} />}
                onClick={async () => {
                  const scale = 3; // Adjust for higher resolution displays
                  const canvas = await html2canvas(componentRef.current, {
                    scale: scale,
                    useCORS: true,
                  });
                  const data = canvas.toDataURL("image/png");
                  // Create an anchor element and trigger the download
                  const link = document.createElement("a");
                  link.href = data;
                  link.download = "image.png"; // The name of the downloaded file
                  link.click();
                }}
              />
            </Tooltip>
          </Stack>
        </Stack>
      </Modal>
    </>
  );
}

export default ReprintQr;
